import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getTipoSocioPorId } from 'services/servicioGet';
import { TipoGenerico } from 'utils/models/types';

interface TipoSocioState {
  tipoSocio: TipoGenerico;
  loadingTipoSocio: boolean;
  errorTipoSocio: string | null;
}

// Estado inicial del slice
const initialState: TipoSocioState = {
  tipoSocio: {
    Id: 0,
    Nombre: '',
  },
  loadingTipoSocio: false,
  errorTipoSocio: null,
};

// Thunk para obtener los alquileres
export const fetchTipoSocio = createAsyncThunk<TipoGenerico, void, { rejectValue: string }>(
  'fetchTipoSocio',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getTipoSocioPorId();
      return response;
    } catch (error: unknown) {
      return rejectWithValue(error instanceof Error ? error.message : String(error));
    }
  }
);

// Slice de tipo de socio por id
const tipoSocioSlice = createSlice({
  name: 'tipoSocio',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchTipoSocio.pending, state => {
        state.loadingTipoSocio = true;
        state.errorTipoSocio = null;
      })
      .addCase(fetchTipoSocio.fulfilled, (state, action) => {
        state.tipoSocio = action.payload;
        state.loadingTipoSocio = false;
      })
      .addCase(fetchTipoSocio.rejected, (state, action) => {
        state.loadingTipoSocio = false;
        state.errorTipoSocio = action.payload as string;
      });
  },
});

export default tipoSocioSlice.reducer;
